export enum ScheduleType {
  League = 'league',
  Tournament = 'tournament',
}

export const ScheduleType_JS = Object.freeze({
  League: 'league',
  Tournament: 'tournament',
});
